import React, { useState, useEffect } from "react";
import "./Home.css";
import { createService } from "../services/api";
import Navbar from "../components/Navbar";
import emailjs from "emailjs-com";
import jsPDF from "jspdf";
import { getReviews, createReview, deleteReview } from "../services/api";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";


function Home() {
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        client_name: "",
        phone: "",
        address: "",
        service_type: "",
        scheduled_date: "",
        hours: 2,
        urgent: false
    });

    const [totalPrice, setTotalPrice] = useState({
        subtotal: 0,
        iva: 0,
        total: 0
    });

    const isAdmin = true;

    const [showPromo, setShowPromo] = useState(false);

    useEffect(() => {

        const reviewSent = localStorage.getItem("reviewSent");

        if (reviewSent) return;

        const popupClosedAt = localStorage.getItem("popupClosedAt");

        if (!popupClosedAt) {

            const timer = setTimeout(() => {
                setShowPromo(true);
            }, 10000);

            return () => clearTimeout(timer);
        }

        const now = Date.now();
        const diff = now - Number(popupClosedAt);

        if (diff > 180000) {

            const timer = setTimeout(() => {
                setShowPromo(true);
            }, 10000);

            return () => clearTimeout(timer);
        }

    }, []);

    const closePromo = () => {

        localStorage.setItem(
            "popupClosedAt",
            Date.now()
        );

        setShowPromo(false);
    };

    const handleRating = (value) => {
        setNewReview({ ...newReview, rating: value });
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        const newValue = type === "checkbox" ? checked : value;

        const updatedForm = {
            ...formData,
            [name]: newValue
        };

        setFormData(updatedForm);

        calculatePrice(updatedForm);
    };

    const calculatePrice = (data) => {
        let pricePerHour = 0;

        if (data.service_type === "vivienda") pricePerHour = 16;
        if (data.service_type === "turistico") pricePerHour = 17;
        if (data.service_type === "gestion_turistica") {
            setTotalPrice({
                subtotal: 0,
                iva: 0,
                total: 0
            });
            return;
        }
        if (data.service_type === "profunda") pricePerHour = 20;
        if (data.service_type === "obra") pricePerHour = 25;

        let subtotal = pricePerHour * (data.hours || 0);

        if (data.urgent) {
            subtotal += 15;
        }

        const iva = subtotal * 0.21;
        const total = subtotal + iva;

        setTotalPrice({
            subtotal,
            iva,
            total
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            //  Guardar en base de datos
            await createService({
                ...formData,
                price: totalPrice.total
            });

            //  Enviar email automático
            await emailjs.send(
                "service_fj7ukak",
                "template_llc45cn",
                {
                    name: formData.client_name,
                    phone: formData.phone,
                    service: formData.service_type,
                    address: formData.address,
                    date: formData.scheduled_date,
                    hours: formData.hours,
                    subtotal: totalPrice.subtotal.toFixed(2),
                    iva: totalPrice.iva.toFixed(2),
                    total: totalPrice.total.toFixed(2)
                },
                "k_QAThMrjBr94TO3X"
            );
            if (window.gtag) {
                window.gtag('event', 'formulario_enviado', {
                    event_category: 'contact',
                    event_label: 'solicitar_presupuesto'
                });
            }

            alert("✅ Solicitud enviada correctamente");

            //  Limpiar formulario
            setFormData({
                client_name: "",
                phone: "",
                address: "",
                service_type: "",
                scheduled_date: "",
                hours: 2,
                urgent: false
            });

            setTotalPrice({
                subtotal: 0,
                iva: 0,
                total: 0
            });

        } catch (error) {
            console.error(error);
            alert("❌ Error al enviar");
        }
    };

    const handleWhatsAppQuote = () => {
        const phone = "34611009814";

        const message = `
Hola, quiero confirmar este servicio:

🧹 Servicio: ${formData.service_type}
📍 Dirección: ${formData.address}
📅 Fecha: ${formData.scheduled_date}
⏱ Horas: ${formData.hours}

💰 Total: ${totalPrice.total?.toFixed(2)} €

Gracias!
    `;

        window.open(
            `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
            "_blank"
        );
    };
    const generatePDF = () => {
        const doc = new jsPDF();

        doc.text("Limpiezas Costa Blanca", 20, 20);

        doc.text(`Cliente: ${formData.client_name}`, 20, 40);
        doc.text(`Servicio: ${formData.service_type}`, 20, 50);
        doc.text(`Horas: ${formData.hours}`, 20, 60);

        doc.text(`Subtotal: ${totalPrice.subtotal} €`, 20, 80);
        doc.text(`IVA: ${totalPrice.iva} €`, 20, 90);
        doc.text(`Total: ${totalPrice.total} €`, 20, 100);

        doc.save("presupuesto.pdf");
    };
    const [selectedService, setSelectedService] = useState(null);

    useEffect(() => {
        document.body.style.overflow = selectedService ? "hidden" : "auto";
    }, [selectedService]);

    const [reviews, setReviews] = useState([]);

    const [newReview, setNewReview] = useState({
        name: "",
        message: "",
        rating: 5
    });

    const handleSelectService = (service) => {
        setFormData({
            ...formData,
            service_type: service
        });

        setSelectedService(null);

        setTimeout(() => {
            document.getElementById("contacto").scrollIntoView({
                behavior: "smooth"
            });
        }, 200);
    };

    const handleReviewSubmit = async (e) => {
        e.preventDefault();

        console.log("CLICK OK");
        console.log(newReview);

        if (newReview.message.length < 10) {
            alert("La opinión debe tener al menos 10 caracteres");
            return;
        }

        if (newReview.name.length < 2) {
            alert("Nombre inválido");
            return;
        }

        try {
            const response = await createReview(newReview);

            console.log("RESPUESTA API:", response);

            alert("Opinión enviada correctamente ✅");
            localStorage.setItem("reviewSent", "true");
            setShowPromo(false);

            setNewReview({
                name: "",
                message: "",
                rating: 5
            });

        } catch (error) {
            console.error("ERROR REVIEW:", error);
            alert("Error enviando opinión");
        }
    };

    const handleDeleteReview = async (id) => {
        await deleteReview(id);

        const data = await getReviews();
        setReviews(data);
    };

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") {
                setSelectedService(null);
            }
        };

        window.addEventListener("keydown", handleEsc);

        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    useEffect(() => {
        if (selectedService) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [selectedService]);

    useEffect(() => {
        if (selectedService) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [selectedService]);

    useEffect(() => {
        const loadReviews = async () => {
            const data = await getReviews();
            setReviews(data);
        };

        loadReviews();
    }, []);

    return (
        <div className="home">

            {/* NAVBAR */}
            <Navbar />
            <div className="hero-video" id="inicio">

                <video autoPlay loop muted playsInline className="video-bg">
                    <source src="/videolcb.mp4" type="video/mp4" />
                </video>

                <div className="overlay">

                    <h1>{t("hero.title")}</h1>

                    <div className="hero-trust">
                        <span>⭐ {t("hero.trust.fast")}</span>
                        <span>⭐ {t("hero.trust.personalized")}</span>
                        <span>⭐ {t("hero.trust.satisfied")}</span>
                    </div>

                    <a
                        href={`https://wa.me/34611009814?text=${encodeURIComponent(
                            t("hero.whatsappMessage")
                        )}`}
                        className="hero-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("hero.button")}
                    </a>

                </div>

            </div>
            <section className="about-section" id="sobre">

                <div className="about-container">

                    {/* TEXTO */}
                    <div className="about-text">
                        <h2>Sobre nosotros</h2>

                        <p>
                            En <strong>Limpiezas Costa Blanca</strong> somos especialistas en la
                            <strong> limpieza de apartamentos turísticos</strong>,
                            <strong> viviendas particulares</strong>,
                            <strong> comunidades de vecinos</strong>,
                            <strong> alojamientos vacacionales</strong> y
                            <strong> gestión de alquiler turístico</strong> en
                            <strong> Benidorm</strong> y toda la
                            <strong> Costa Blanca</strong>. Prestamos servicio profesional en
                            <strong> Altea</strong>, <strong>Altea Hills</strong>,
                            <strong> Albir</strong>, <strong>Cala de Finestrat</strong>,
                            <strong> Villajoyosa</strong>, <strong>La Nucía</strong> y
                            <strong> Mascarat</strong>, ofreciendo soluciones adaptadas tanto para
                            particulares como para propietarios, empresas y comunidades.
                        </p>

                        <p>
                            Realizamos <strong>limpieza de viviendas</strong>,
                            <strong> limpieza de apartamentos turísticos</strong>,
                            <strong> limpieza de comunidades de propietarios</strong>,
                            <strong> limpieza fin de obra</strong>,
                            <strong> limpiezas profundas</strong> y
                            <strong> gestión integral de alquileres vacacionales</strong>,
                            garantizando siempre un servicio puntual, profesional y de máxima calidad.
                        </p>

                        <p>
                            Para los propietarios que anuncian sus viviendas en
                            <strong> Airbnb</strong> y <strong>Booking</strong>, entendemos la
                            importancia de cada <strong>cambio de huésped</strong>. Cuidamos cada
                            detalle para que el alojamiento esté impecable, organizado y preparado
                            para ofrecer una excelente primera impresión, favoreciendo
                            <strong> mejores valoraciones</strong> y
                            <strong> reseñas positivas</strong>.
                        </p>

                        <p>
                            También ofrecemos un servicio profesional de
                            <strong> limpieza y mantenimiento de comunidades de vecinos</strong>,
                            incluyendo portales, escaleras, ascensores y zonas comunes, adaptándonos
                            a las necesidades de cada comunidad con planes de limpieza periódicos y
                            totalmente personalizados.
                        </p>

                        <p>
                            Nos adaptamos a los horarios y necesidades de cada cliente,
                            proporcionando un servicio de limpieza rápido, eficaz y de confianza.
                            Nuestro compromiso es ofrecer espacios limpios, seguros y perfectamente
                            preparados, aportando tranquilidad, profesionalidad y una atención al
                            detalle que nos diferencia en toda la Costa Blanca.
                        </p>

                        <div className="about-features">
                            <span>✔ Gestión de alquiler turístico</span>
                            <span>✔ Limpieza de comunidades</span>
                            <span>✔ Limpieza de viviendas</span>
                            <span>✔ Servicio de lavandería</span>
                            <span>✔ Benidorm y Costa Blanca</span>
                            <span>✔ Presupuestos gratuitos</span>
                        </div>
                    </div>

                    {/* IMAGEN */}
                    <div className="about-image">
                        <img src="/imagen-lcb.png" alt="Equipo de limpieza profesional" />
                    </div>

                </div>
            </section>

            <section className="zonas">

                <h2 className="section-title">
                    Servicio de limpieza en Benidorm y alrededores
                </h2>

                <p className="section-subtitle">
                    Nos desplazamos con transporte propio por toda la Costa Blanca
                </p>

                <div className="zonas-grid">

                    <Link to="/limpieza-benidorm" className="zona-card">
                        Benidorm
                    </Link>
                    <Link to="/limpieza-altea" className="zona-card">
                        Altea
                    </Link>
                    <Link to="/limpieza-altea-hills" className="zona-card">
                        Altea Hills
                    </Link>
                    <Link to="/limpieza-mascarat" className="zona-card">
                        Mascarat
                    </Link>
                    <Link to="/limpieza-albir" className="zona-card">
                        Albir
                    </Link>
                    <Link to="/limpieza-cala-de-finestrat" className="zona-card">
                        Cala de Finestrat
                    </Link>
                    <Link to="/limpieza-villajoyosa" className="zona-card">
                        Villajoyosa
                    </Link>
                    <Link to="/limpieza-la-nucia" className="zona-card">
                        La Nucía
                    </Link>

                </div>

                <p className="zonas-text">
                    Realizamos limpieza de apartamentos turísticos, viviendas vacacionales y
                    propiedades privadas con servicio rápido y profesional en toda la zona
                    de Benidorm y alrededores.
                </p>

            </section>

            {/* SERVICIOS */}
            <section className="services" id="servicios">
                <h2>Nuestros Servicios</h2>
                <p>Ofrecemos soluciones de limpieza adaptadas a cada necesidad, combinando
                    profesionalismo, eficiencia y atención al detalle en cada servicio.</p>

                <div className="cards">

                    <div className="card" onClick={() => setSelectedService("vivienda")}>
                        <h3>🏠 Limpieza de viviendas</h3>
                        <p>Servicio completo para casas y apartamentos.</p>
                    </div>

                    <div
                        className="card"
                        onClick={() => setSelectedService("turistico")}
                    >
                        <h3>🏖 Limpieza de alquiler vacacional</h3>
                        <p>Servicio especializado para alquileres turísticos.</p>
                    </div>

                    <div className="card" onClick={() => setSelectedService("gestion_turistica")}>
                        <h3>🏡 Gestión de alquiler turístico</h3>
                        <p>Nos encargamos de la gestión integral de tu vivienda vacacional.</p>
                    </div>

                    <div className="card" onClick={() => setSelectedService("profunda")}>
                        <h3>✨ Limpieza profunda</h3>
                        <p>Eliminamos suciedad difícil y acumulada.</p>
                    </div>

                    <div className="card" onClick={() => setSelectedService("obra")}>
                        <h3>🧱 Final de obra</h3>
                        <p>Dejamos tu espacio listo para usar.</p>
                    </div>

                </div>
            </section>

            <section className="gallery">
                <h2 className="gallery-title">
                    Resultados que hablan por nosotros ✨
                </h2>

                <p className="gallery-subtitle">
                    Mira cómo transformamos cada espacio con nuestro servicio profesional
                </p>

                <div className="carousel">

                    <div className="carousel-track">

                        <div className="img-box">
                            <img
                                src="https://i.pinimg.com/736x/b4/cb/74/b4cb745032c177580975516819de7f92.jpg"
                                alt="Limpieza profesional de cocina en Benidorm"
                            />
                        </div>

                        <div className="img-box">
                            <img
                                src="https://i.pinimg.com/736x/fc/3f/12/fc3f12dfee374114b959872e98bedd29.jpg"
                                alt="Limpieza de salón moderno y ordenado"
                            />
                        </div>

                        <div className="img-box">
                            <img
                                src="https://i.pinimg.com/1200x/2d/08/22/2d08228dbfe374ac296bdca2c5760273.jpg"
                                alt="Baño limpio y desinfectado profesionalmente"
                            />
                        </div>

                        <div className="img-box">
                            <img
                                src="https://i.pinimg.com/1200x/99/21/2e/99212e1aba0610a0954db70768d8d343.jpg"
                                alt="Servicio de limpieza profunda en vivienda"
                            />
                        </div>

                        <div className="img-box">
                            <img
                                src="https://i.pinimg.com/1200x/ee/a1/0e/eea10e34f4e8b689da8599d6bdb081a0.jpg"
                                alt="Limpieza de apartamentos turísticos en Benidorm"
                            />
                        </div>

                        <div className="img-box">
                            <img
                                src="https://i.pinimg.com/736x/32/69/6c/32696c098d7af7d061550ad843538153.jpg"
                                alt="Resultados de limpieza profesional en baño"
                            />
                        </div>

                    </div>

                </div>
            </section>

            <section className="reviews" id="reviews">

                <h2 className="section-title">Lo que dicen nuestros clientes</h2>
                <p className="section-subtitle">Opiniones reales de nuestros clientes</p>

                {/* REVIEWS DINÁMICAS */}
                <div className="reviews-container">

                    {reviews.length === 0 ? (
                        <p>Cada cliente satisfecho nos ayuda a seguir creciendo ⭐</p>
                    ) : (
                        reviews.map((rev) => (
                            < div key={rev.id} className="review-card" >

                                <div className="review-stars">
                                    {"★".repeat(rev.rating)}{"☆".repeat(5 - rev.rating)}
                                </div>

                                <p className="review-message">
                                    "{rev.message}"
                                </p>

                                <span className="review-name">
                                    — {rev.name}
                                </span>

                                {isAdmin && (
                                    <button
                                        className="delete-review"
                                        onClick={() => handleDeleteReview(rev.id)}
                                    >
                                        Eliminar
                                    </button>
                                )}

                            </div>
                        ))
                    )}

                </div>

                {/* FORMULARIO */}
                <form onSubmit={handleReviewSubmit} className="review-form">

                    <h3>Déjanos tu opinión</h3>

                    <input
                        type="text"
                        placeholder="Tu nombre"
                        value={newReview.name}
                        onChange={(e) =>
                            setNewReview({ ...newReview, name: e.target.value })
                        }
                        required
                    />

                    <textarea
                        placeholder="Escribe tu experiencia..."
                        value={newReview.message}
                        onChange={(e) =>
                            setNewReview({ ...newReview, message: e.target.value })
                        }
                        required
                    />

                    <button type="submit" className="primary-btn">
                        Enviar opinión
                    </button>
                    <div className="stars">
                        {[1, 2, 3, 4, 5].map((star) => (
                            <span
                                key={star}
                                className={star <= newReview.rating ? "star active" : "star"}
                                onClick={() => handleRating(star)}
                            >
                                ★
                            </span>
                        ))}
                    </div>

                </form>

            </section >
            {/* CTA */}
            < section className="cta" >
                <h2>¿Necesitas limpieza urgente?</h2>
                <p>Contáctanos y te damos presupuesto en minutos</p>

                <button
                    className="primary-btn"
                    onClick={() => {
                        const phone = "34611009814";
                        const message = "Hola, necesito un servicio de limpieza urgente";
                        window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`);
                    }}
                >
                    Contactar ahora
                </button>
            </section >

            {/* FORMULARIO */}
            < section className="form-section" id="contacto" >
                <h2>Solicita tu presupuesto</h2>
                <p>Rellena el siguiente formulario y te contactaremos lo antes posible.</p>

                <form onSubmit={handleSubmit} className="form">

                    <input
                        name="client_name"
                        placeholder="Nombre"
                        value={formData.client_name}
                        onChange={handleChange}
                        required
                    />

                    <input
                        name="phone"
                        placeholder="Teléfono"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                    />

                    <input
                        name="address"
                        placeholder="Dirección"
                        value={formData.address}
                        onChange={handleChange}
                    />

                    {/* SELECT (IMPORTANTE) */}
                    <select
                        name="service_type"
                        value={formData.service_type}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Selecciona servicio</option>
                        <option value="vivienda">
                            Limpieza de vivienda (15€/h + IVA → 18,15€/h)
                        </option>
                        <option value="turistico">
                            Alquiler turístico (15€/h + IVA → 18,15€/h)
                        </option>
                        <option value="profunda">
                            Limpieza profunda (16€/h + IVA → 19,36€/h)
                        </option>
                        <option value="obra">
                            Final de obra (18€/h + IVA → 21,78€/h)
                        </option>
                    </select>
                    {/* HORAS */}
                    <select
                        name="hours"
                        value={formData.hours}
                        onChange={handleChange}
                    >
                        <option value={2}>2 horas</option>
                        <option value={3}>3 horas</option>
                        <option value={4}>4 horas</option>
                        <option value={5}>5 horas</option>
                    </select>

                    <input
                        type="date"
                        name="scheduled_date"
                        value={formData.scheduled_date}
                        onChange={handleChange}
                        required
                    />
                    <label className="legal-check">
                        <input type="checkbox" required />
                        He leído la <a href="/privacidad">Política de privacidad</a> y acepto el tratamiento de mis datos para la solicitud realizada.
                    </label>

                    <button type="submit" className="primary-btn">
                        Enviar solicitud
                    </button>

                </form>
                {
                    totalPrice.total > 0 && (
                        <>
                            <div className="price-box">

                                <h3>💰 Presupuesto estimado</h3>

                                <div className="price-line">
                                    <span>Subtotal:</span>
                                    <span>{totalPrice.subtotal.toFixed(2)} €</span>
                                </div>

                                <div className="price-line">
                                    <span>IVA (21%):</span>
                                    <span>{totalPrice.iva.toFixed(2)} €</span>
                                </div>

                                {formData.urgent && (
                                    <div className="price-line">
                                        <span>Urgente:</span>
                                        <span>+10€</span>
                                    </div>
                                )}

                                <hr />

                                <div className="price-total">
                                    <strong>Total:</strong>
                                    <strong>{totalPrice.total.toFixed(2)} €</strong>
                                </div>

                            </div>

                            {/* 👇 BOTÓN AQUÍ */}
                            <button
                                className="whatsapp-confirm-btn"
                                onClick={handleWhatsAppQuote}
                            >
                                ✅ Confirmar por WhatsApp
                            </button>
                            <button
                                onClick={generatePDF}
                                className="primary-btn"
                                style={{ marginTop: "10px" }}
                            >
                                Descargar presupuesto PDF
                            </button>
                        </>
                    )
                }
                <div className="pricing-info">
                    <h3>💶 Tarifas orientativas</h3>

                    <p>✔ Limpieza de viviendas: <strong>15€/hora + IVA</strong></p>
                    <p>✔ Alquiler turístico: <strong>15€/hora + IVA</strong></p>
                    <p>✔ Limpieza profunda: <strong>16€/hora + IVA</strong></p>
                    <p>✔ Final de obra: <strong>18€/hora + IVA</strong></p>

                    <small>*El precio final puede variar según tamaño y estado del espacio, se realiza el servicio con un minimo de 2 horas.</small>
                </div>

                {/* WHATSAPP */}
                <button
                    className="whatsapp-btn"
                    onClick={() => {
                        const message = "Hola, quiero solicitar un servicio de limpieza";
                        const phone = "34611009814";

                        window.open(
                            `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
                            "_blank"
                        );
                    }}
                >
                    Escríbenos por WhatsApp
                </button>

            </section >

            {selectedService && (
                <div className="modal-overlay" onClick={() => setSelectedService(null)}>

                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>

                        <button className="modal-close" onClick={() => setSelectedService(null)}>
                            ✖
                        </button>

                        {/* VIVIENDA */}
                        {selectedService === "vivienda" && (
                            <div className="modal-body">

                                <div className="modal-text">
                                    <h2>Limpieza de viviendas</h2>

                                    <p>
                                        Servicio profesional para mantener tu hogar impecable,
                                        con atención al detalle y productos de alta calidad.
                                    </p>

                                    <p><strong>Incluye:</strong></p>

                                    <ul>
                                        <li>✔ Limpieza de cocina y baños</li>
                                        <li>✔ Aspirado y fregado</li>
                                        <li>✔ Eliminación de polvo</li>
                                        <li>✔ Limpieza de superficies</li>
                                        <li>✔ Cambio de ropa de cama</li>
                                    </ul>

                                    <p><strong>💰 15€/hora + IVA</strong></p>

                                    <div className="modal-actions">

                                        <button
                                            className="primary-btn"
                                            onClick={() => handleSelectService("vivienda")}
                                        >
                                            Reservar limpieza vivienda
                                        </button>

                                        <a
                                            href="/limpieza-viviendas-benidorm"
                                            className="secondary-btn"
                                        >
                                            Ver servicio completo
                                        </a>

                                    </div>
                                </div>

                                <div className="modal-image">
                                    <img src="/imagen-lcb.png" alt="Servicio vivienda" />
                                </div>

                            </div>
                        )}

                        {/* TURISTICO */}
                        {selectedService === "turistico" && (
                            <div className="modal-body">

                                <div className="modal-text">
                                    <h2>Limpieza de alquileres turísticos</h2>

                                    <p>
                                        Preparamos tu vivienda para cada huésped como si fuera un hotel,
                                        cuidando cada detalle para ofrecer una experiencia impecable.
                                    </p>

                                    <ul>
                                        <li>✔ Limpieza completa tras cada salida</li>
                                        <li>✔ Cambio de sábanas y toallas</li>
                                        <li>✔ Preparación tipo hotel</li>
                                        <li>✔ Reposición de básicos</li>
                                        <li>✔ Revisión general del inmueble</li>
                                    </ul>

                                    <p className="price">
                                        💰 15€/hora + IVA
                                    </p>

                                    <div className="modal-actions">

                                        <button
                                            className="primary-btn"
                                            onClick={() => handleSelectService("turistico")}
                                        >
                                            Reservar limpieza turística
                                        </button>

                                        <a
                                            href="/limpieza-pisos-turisticos-benidorm"
                                            className="secondary-btn"
                                        >
                                            Ver servicio completo
                                        </a>

                                    </div>
                                </div>

                                <div className="modal-image">
                                    <img src="/limpieza-turistica.jpg" alt="Alquileres turísticos" />
                                </div>

                            </div>
                        )}

                        {/* GESTIÓN ALQUILER TURÍSTICO */}
                        {selectedService === "gestion_turistica" && (
                            <div className="modal-body">

                                <div className="modal-text">
                                    <h2>Gestión de alquiler turístico</h2>

                                    <p>
                                        Nos encargamos de la gestión operativa de tu vivienda vacacional
                                        para que puedas maximizar la rentabilidad sin preocuparte por el día a día.
                                    </p>

                                    <p><strong>Incluye:</strong></p>

                                    <ul>
                                        <li>Check-in y check-out de huéspedes</li>
                                        <li>Atención al cliente</li>
                                        <li>Servicio de limpieza</li>
                                        <li>Reposición de suministros</li>
                                        <li>Control de incidencias</li>
                                        <li>Seguimiento operativo</li>

                                    </ul>

                                    <p>
                                        Ideal para propietarios que desean delegar la gestión de su
                                        vivienda turística y ofrecer una experiencia profesional a sus huéspedes.
                                    </p>

                                    <p><strong>💰 Presupuesto personalizado</strong></p>

                                    <div className="modal-actions">

                                        <button
                                            className="primary-btn"
                                            onClick={() => handleSelectService("gestion_turistica")}
                                        >
                                            Solicitar presupuesto
                                        </button>

                                        <a
                                            href="/gestion-alquiler-turistico-benidorm"
                                            className="secondary-btn"
                                        >
                                            Ver servicio completo
                                        </a>

                                    </div>
                                </div>

                                <div className="modal-image">
                                    <img
                                        src="/gestion-turistica.jpeg"
                                        alt="Gestión de alquiler turístico"
                                    />
                                </div>

                            </div>
                        )}

                        {/* PROFUNDA */}
                        {selectedService === "profunda" && (
                            <div className="modal-body">

                                <div className="modal-text">
                                    <h2>Limpieza profunda</h2>

                                    <p>
                                        Eliminamos la suciedad acumulada en profundidad, dejando tu vivienda
                                        completamente renovada. Ideal para cambios de temporada o espacios
                                        que necesitan una limpieza intensiva.
                                    </p>

                                    <ul>
                                        <li>✔ Desinfección completa del hogar</li>
                                        <li>✔ Limpieza a fondo de cocina y baño</li>
                                        <li>✔ Eliminación de grasa, cal y suciedad incrustada</li>
                                        <li>✔ Atención a zonas difíciles y detalles</li>
                                    </ul>

                                    <p className="price">
                                        💰 18€/hora + IVA
                                    </p>

                                    <div className="modal-highlight">
                                        <p>✨ Resultados visibles desde la primera limpieza</p>
                                        <p>🧼 Ideal para viviendas muy usadas o cambios de temporada</p>
                                    </div>

                                    <div className="modal-actions">

                                        <button
                                            className="primary-btn"
                                            onClick={() => handleSelectService("profunda")}
                                        >
                                            Reservar limpieza profunda
                                        </button>

                                        <a
                                            href="/limpieza-profunda-benidorm"
                                            className="secondary-btn"
                                        >
                                            Ver servicio completo
                                        </a>

                                    </div>
                                </div>

                                <div className="modal-image">
                                    <img src="/profunda.jpg" alt="Limpieza profunda en Benidorm" />
                                </div>

                            </div>
                        )}
                        {/* OBRA */}
                        {selectedService === "obra" && (
                            <div className="modal-body">

                                <div className="modal-text">
                                    <h2>Limpieza fin de obra</h2>

                                    <p>
                                        Dejamos tu vivienda completamente lista para entrar a vivir después
                                        de una reforma o construcción. Eliminamos todo rastro de polvo,
                                        restos de obra y suciedad acumulada.
                                    </p>

                                    <ul>
                                        <li>✔ Eliminación de polvo de obra en todas las superficies</li>
                                        <li>✔ Limpieza de restos de pintura, yeso y materiales</li>
                                        <li>✔ Cristales, ventanas y marcos a fondo</li>
                                        <li>✔ Aspirado y fregado intensivo</li>
                                    </ul>

                                    <p className="price">
                                        💰 18€/hora + IVA
                                    </p>

                                    <div className="modal-highlight">
                                        <p>🏡 Espacio listo para entrar a vivir</p>
                                        <p>🧼 Limpieza profesional tras reformas o nuevas construcciones</p>
                                    </div>

                                    <div className="modal-actions">

                                        <button
                                            className="primary-btn"
                                            onClick={() => handleSelectService("obra")}
                                        >
                                            Reservar limpieza fin de obra
                                        </button>

                                        <a
                                            href="/limpieza-fin-obra-benidorm"
                                            className="secondary-btn"
                                        >
                                            Ver servicio completo
                                        </a>

                                    </div>
                                </div>

                                <div className="modal-image">
                                    <img src="/post-obra.jpg" alt="Limpieza fin de obra en Benidorm" />
                                </div>

                            </div>
                        )}
                    </div>
                </div>
            )
            }
            <a
                href="https://wa.me/34611009814"
                className="whatsapp-float"
                onClick={() => {
                    if (window.gtag) {
                        window.gtag('event', 'click_whatsapp', {
                            event_category: 'contact',
                            event_label: 'boton_whatsapp'
                        });
                    }
                }}
            >
                <img src="/whatsapp-icon-white.png" alt="WhatsApp" />
            </a>

            {
                !localStorage.getItem("cookiesAccepted") && (
                    <div className="cookie-banner">
                        <p>
                            Utilizamos cookies para mejorar tu experiencia. Al continuar aceptas nuestra{" "}
                            <a href="/cookies">Política de cookies</a>.
                        </p>

                        <button
                            onClick={() => {
                                localStorage.setItem("cookiesAccepted", "true");
                                window.location.reload();
                            }}
                        >
                            Aceptar
                        </button>
                    </div>
                )
            }
            {
                showPromo && (
                    <div className="promo-overlay" onClick={() => setShowPromo(false)}>

                        <div className="promo-modal" onClick={(e) => e.stopPropagation()}>

                            <button
                                className="close-popup"
                                onClick={closePromo}
                            >
                                ✕
                            </button>

                            <h2>🎉 10% de descuento en tu primera limpieza</h2>

                            <p>
                                Aprovecha esta oferta exclusiva y deja tu hogar impecable
                                con nuestro servicio profesional en Benidorm y alrededores.
                            </p>

                            <a
                                href="https://wa.me/34611009814?text=Hola,%20quiero%20aprovechar%20el%2010%25%20de%20descuento"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="promo-btn"
                            >
                                Obtener descuento por WhatsApp
                            </a>

                        </div>

                    </div>
                )
            }
            <Footer />
        </div >

    );
}

export default Home;